"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.totpVerify = exports.totpValidateProfile = exports.totpValidate = exports.totpSuccess = exports.totpReset = exports.totpPublic = exports.totpFetch = exports.totpError = exports.totpDelete = void 0;
var _totp = require("./totp.constant");
// @flow

// common success
var totpSuccess = function totpSuccess(actionType, data) {
  return {
    type: _totp.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.totpSuccess = totpSuccess;
var totpError = function totpError(actionType, error) {
  return {
    type: _totp.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fetch totp
 * @param payload
 * @returns api response
 * @description this function used to fetch totp.
 */
exports.totpError = totpError;
var totpFetch = function totpFetch(data) {
  return {
    type: _totp.actionTypes.FETCH,
    payload: data
  };
};

/**
 * public totp
 * @param payload
 * @returns api response
 * @description this function used to public totp.
 */
exports.totpFetch = totpFetch;
var totpPublic = function totpPublic(data) {
  return {
    type: _totp.actionTypes.PUBLIC,
    payload: data
  };
};

/**
 * validate totp
 * @param payload
 * @returns api response
 * @description this function used to validate totp.
 */
exports.totpPublic = totpPublic;
var totpValidate = function totpValidate(data) {
  return {
    type: _totp.actionTypes.VALIDATE,
    payload: data
  };
};

/**
 * validate totp
 * @param payload
 * @returns api response
 * @description this function used to validate totp.
 */
exports.totpValidate = totpValidate;
var totpValidateProfile = function totpValidateProfile(data) {
  return {
    type: _totp.actionTypes.VALIDATE_PROFILE,
    payload: data
  };
};

/**
 * verify totp
 * @param payload
 * @returns api response
 * @description this function used to verify totp.
 */
exports.totpValidateProfile = totpValidateProfile;
var totpVerify = function totpVerify(data) {
  return {
    type: _totp.actionTypes.VERIFY,
    payload: data
  };
};

/**
 * delete totp
 * @param payload
 * @returns api response
 * @description this function used to verify totp.
 */
exports.totpVerify = totpVerify;
var totpDelete = function totpDelete(data) {
  return {
    type: _totp.actionTypes.DELETE,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset totp.
 */
exports.totpDelete = totpDelete;
var totpReset = function totpReset() {
  return {
    type: _totp.actionTypes.RESET
  };
};
exports.totpReset = totpReset;